import React from "react";
import { Layout } from "./components/Layout";

export default function PrinciplesPage() {
  return (
    <Layout>
    <div style={{ maxWidth: "800px", margin: "0 auto" }}>

    <div className="container mt-4">
      <h1>Our Principles</h1><br/>

      <h2>1. High expectations for every student</h2>
      <p>
        We believe all students can achieve at a high level. Our platform is
        designed to ensure every learner experiences challenge, growth, and
        success. High expectations shape outcomes, so we build systems that help
        students rise to their potential rather than be defined by their
        starting point.
      </p>

      <h2>2. A rigorous, coherent curriculum</h2>
      <p>
        Our curriculum is built on the NSW Syllabus, ensuring every student
        learns through a structured, knowledge‑rich progression. It is clear
        about what matters, logically sequenced, and consistent across tutors
        and sessions. A coherent curriculum prevents learning gaps, supports
        cumulative knowledge building, and gives tutors the clarity they need to
        deliver effective, evidence‑based instruction.
      </p>

      <h2>3. Expert, well‑supported tutors</h2>
      <p>
        We select only the most capable tutors and equip them with the tools,
        training, and resources they need to excel. Tutors are treated as
        professionals: supported through coaching, connected through shared
        practice, and empowered to deliver exceptional learning experiences.
      </p>

      <h2>4. Early intervention and targeted support</h2>
      <p>
        We identify learning needs early through regular, low‑stakes diagnostic
        assessments. Our one‑on‑one tutoring focuses first on foundational gaps,
        ensuring small misunderstandings never grow into structural barriers.
        Instruction is responsive, personalised, and grounded in evidence.
      </p>

      <h2>5. Equitable access to resources</h2>
      <p>
        Every student deserves high‑quality learning materials. We provide our
        resources free to all, ensuring that opportunity is not determined by
        postcode, background, or family income. Equity is a design principle,
        not an afterthought.
      </p>

      <h2>6. A culture of continuous improvement</h2>
      <p>
        We seek feedback from tutors, students, and families to refine our
        practice. Data informs our decisions, innovation is encouraged, and
        learning from mistakes is normalised. Improvement becomes a habit, not a
        project — a shared commitment to getting better every day.
      </p>

      <h2>7. Deep family and community engagement</h2>
      <p>
        Students thrive when families feel connected to their learning. We build
        strong partnerships through clear communication, shared expectations, and
        accessible tools that help families understand and support progress.
        Engagement is collaborative, respectful, and central to student success.
      </p>

      <h2>8. Psychological safety and student wellbeing</h2>
      <p>
        Learning accelerates when students feel safe, supported, and respected.
        We foster environments where mistakes are part of learning, questions are
        welcomed, and every student feels valued. Wellbeing is not separate from
        academic growth — it enables it.
      </p>

      <h2>9. Fair, transparent assessment</h2>
      <p>
        Assessment should guide teaching, provide meaningful feedback, and
        support learning. Our approach is clear, consistent, and aligned with
        curriculum expectations. Students and families understand what is being
        assessed, why it matters, and how it informs the next steps in learning.
      </p>
    </div>
    </div>
        </Layout>

  );
}